export default __webpack_public_path__ + "static/media/kn.77f64db8.svg";